import React from "react";
import { MilestoneProvider } from "./context/MilestoneContext";
import { MilestoneComponentContent } from "./components/MilestoneComponentContent";
import { MilestoneComponentProps } from "./types/milestoneComponent.types";

/**
 * Main milestone component that provides context and renders milestone content
 * Optimized with React Context to reduce props drilling and improve performance
 */
const MilestoneComponent: React.FC<MilestoneComponentProps> = ({
     homeSiteId,
     exceptionCount,
     alertsCount,
     notesCount,
     userId,
     updateMilestoneTasks,
     milestoneName,
     saleDate,
     closeOfEscrowActual,
     closeOfEscrowEstimated,
     setMilestoneTab,
}) => {
     return (
          <MilestoneProvider
               homeSiteId={homeSiteId}
               exceptionCount={exceptionCount}
               alertsCount={alertsCount}
               notesCount={notesCount}
               userId={userId}
               updateMilestoneTasks={updateMilestoneTasks}
               saleDate={saleDate}
               closeOfEscrowActual={closeOfEscrowActual}
               closeOfEscrowEstimated={closeOfEscrowEstimated}
               setMilestoneTab={setMilestoneTab}
          >
               <MilestoneComponentContent milestoneName={milestoneName} />
          </MilestoneProvider>
     );
};

// Export memoized component to prevent unnecessary re-renders
export default React.memo(MilestoneComponent);  